<template>
  <v-card
    flat
    tile
    :class="[
      'd-flex', 'mx-auto', 
      {
            'mt-3 mb-1': $route.name === 'Producto',
          },
          {
            'mt-n5': $route.name !== 'Producto',
          },
        ]"
    v-if="!Cliente.showOpc && dataUser.IndAutenticado"
  >
    <v-card-actions>
      <v-btn
        small
        class="mr-1"
        fab
        color="primary"
        depressed
        text
        @click="decrement"
        ><v-icon size="30"> mdi-minus </v-icon></v-btn
      >
      <v-text-field
        v-model="count"
        :label="`${formatNumber(
          contCantidad({ contmayor: item.ContentMayor, cant: count })
        )}${validaContenido ? ' M2' : ' Uni'}`"
        color="primary"
        class="warning-200"
        dense
        type="tel"
        @keypress="isNumber($event)"
        hide-details
        style="width: 70px; font-size: 1.3rem"
        reverse
      ></v-text-field>
      <v-btn
        class="mr-2 ml-1"
        small
        fab
        color="primary"
        depressed
        text
        @click="increment"
      >
        <v-icon size="30"> mdi-plus </v-icon></v-btn
      >
      <v-btn
        :color="isCar(item.Codigo) === 0 ? 'accent' : 'primary'"
        fab
        dark
        small
        bottom
        :loading="loading"
        right
        style="z-index: 1"
        :class="[
          {
            'mb-1': $route.name === 'Producto',
          },
          {
            'mr-n5': $route.name !== 'Producto',
          },
        ]"
        elevation="0"
        @click="
          addCar({
            articulo: item.Codigo,
            promo: 0,
            cantidad: formatNumber(
              contCantidad({ contmayor: item.ContentMayor, cant: count })
            ),
          })
        "
        ><v-icon
          :color="isCar(item.Codigo) === 0 ? 'success-100' : 'success-400'"
        >
          {{
            `mdi-${isCar(item.Codigo) === 0 ? `cart-plus` : `cart-check`}`
          }}</v-icon
        ></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    item: Object | Array,
  },
  data() {
    return {
      count: 1,
      loading: false,
    };
  },
  computed: {
    ...mapState(["domoapi2_img", "Cliente", "dataUser", "Pedido"]),
    contCantidad: function () {
      return function ({ contmayor, cant }) {
        return this.validaContenido ? contmayor * cant : cant;
      };
    },
    isCar: function () {
      return function (cod) {
        return this.Pedido.items
          .filter((x) => x["Codigo"] === cod)
          .map((x) => x["Codigo"]).length;
      };
      //
    },
    validaContenido() {
      const { ContentDetal } = this.item;
      return ContentDetal !== 1;
    },
  },
  methods: {
    ...mapActions(["set_cargaArtCarrito"]),
    ...mapMutations(["set_mensaje"]),
    async addCar({ articulo, promo, cantidad }) {
      this.loading = true;
      await this.set_cargaArtCarrito({
        articulo,
        cantidad,
        promo,
      });

      this.loading = false;
    },
    formatNumber(num) {
      return parseFloat(num).toFixed(2);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 9) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    increment() {
      this.count++;
    },
    decrement() {
      if (this.count > 1) {
        this.count--;
      }
    },
  },
};
</script>
